import React, { useState, useEffect } from 'react';
import { 
    Button,
    Card,
    Chip,
    Grid,
    IconButton,
    Paper,
    CardHeader,
    CardMedia
   } from '@material-ui/core';
import { 
       DeleteForever as DeleteForeverIcon,
       CloudUpload as CloudUploadIcon,
       Done as DoneIcon,
       Help as HelpIcon,
   } from '@material-ui/icons';
import {
    LoadingOutlined as LoadingOutlinedIcon,
} from '@ant-design/icons';
import Viewer from 'react-viewer';
import { v4 as uuidv4 } from 'uuid';


const UploadElementYouNET = ({classes, info, handleUpdatePhoto, idForMikrotik, handleDeletePhoto, idServicio, idCliente, getArrPhotos, enqueueSnackbar})=>{
    const [ photoReport, setPhotoReport ] = useState();
    const [ photoReportPreview, setPhotoReportPreview ] = useState('');
    const [ showElement, setShowElement ]= useState(false);
    const [ isSelectElement, setElementSelect ] =useState (false);
    const [ openPhotos, setOpenPhotos ] = useState(false);
    const [ modePhoto, setModePhoto ] = useState(false);
    const [ continuoPhoto, setContinuoPhoto ] = useState(false);
    const [ getUpImage, setUpImage ] = useState(false);

    useEffect(()=>{
        if(info.src !== ''){
            if(info.src.length > 0){
                setModePhoto(true);
            }
        }
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(showElement)setShowElement(false);
    },[showElement]);

    useEffect(()=>{
        if(continuoPhoto){
            setContinuoPhoto(false);
            setModePhoto(true);
        }
    },[continuoPhoto]);

    const handleSubmitPhotoReport = (e)=> { 
        setUpImage(true);
        e.preventDefault();
        let name = uuidv4();
        const nombreImagen = `${idForMikrotik}_${name}.${photoReport.name.split('.').pop().toString()}`;
        let formD = new FormData();
        formD.append('imagen',photoReport, nombreImagen);
        fetch('/Servicios/FotosReferencia',{method:'POST',body:formD})
        .then(response => response.json())
        .then(result => {             
            if(result.message){
                const objeto = {...info};
                objeto.src = `/fotosRef/${nombreImagen}`;
                const arr_ = getArrPhotos.map(el=>{
                    if(el.id === info.id){
                        return objeto
                    }else{
                        return el
                    }
                })             
                const objeto2 = {};
                objeto2.idCliente = idCliente;
                objeto2.idServicio = idServicio;
                objeto2.FotosArr = arr_;
                fetch('/api/clientes/serviciosFotos',{
                    method:'PUT',
                    body: JSON.stringify(objeto2),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result2 =>{
                    if(result2.message){
                        enqueueSnackbar(result2.message, {variant:'success'});
                        handleUpdatePhoto(arr_); 
                        setContinuoPhoto(true);
                        setUpImage(false);
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                        setUpImage(false);
                    }
                })
            }else{
                enqueueSnackbar(result.status, {variant:'error'})
                setUpImage(false);
            }
        });
    };

    const handleImageChangeReport = (e)=>{
        
        e.preventDefault();
    
        let reader = new FileReader();
        let file = e.target.files[0];
    
        reader.onloadend = () => {
            setPhotoReport(file);
            setPhotoReportPreview(reader.result);
            setElementSelect(true);
        }
    
        reader.readAsDataURL(file)
    };

    const handleDeleteImage = ()=>{
        if(modePhoto){
            const conf = window.confirm('SE ELIMINARA ESTA IMAGEN DE LA BASE DE DATOS');
            if(conf){
                const nameImage = info.src.split('/').pop().toString();
                // console.log(nameImage);
                fetch('/Servicios/FotosReferencia',{
                    method: 'DELETE',
                    body: JSON.stringify({nameImage}),
                    headers:{
                      'Content-Type':'application/json'
                    }
                })
                .then(response => response.json())
                .then(result => {             
                    if(result.message){
                        const arr_ = getArrPhotos.filter(el=> el.id !== info.id);
                        const objeto = {};
                        objeto.idCliente = idCliente;
                        objeto.idServicio = idServicio;
                        objeto.FotosArr = arr_;
                        fetch('/api/clientes/serviciosFotos',{
                            method:'PUT',
                            body: JSON.stringify(objeto),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(result2 =>{
                            if(result2.message){
                                enqueueSnackbar(result2.message, {variant:'success'});
                                handleUpdatePhoto(arr_); 
                                setModePhoto(false);
                            }else{
                                enqueueSnackbar(result.status, {variant:'error'});
                            }
                        })
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                    }
                });
            }
        }else{
            setPhotoReport();
            setPhotoReportPreview('');
            setShowElement(true);
            setElementSelect(false);
            handleDeletePhoto(info);
        }
        
    };

    const HandleClosePhotos = ()=>{ setOpenPhotos(false);};

    const HandleShowPhotos = ()=>{
        if(modePhoto){
            setOpenPhotos(true);
        }else{
            if(photoReportPreview === ''){
                alert('NO HAY FOTOS')
             }else{
                 setOpenPhotos(true);
             }
        }
        
    };

    return(
        <Grid container className={classes.containerUpload} justifyContent='center'>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Viewer
                    visible={openPhotos}
                    onClose={HandleClosePhotos}
                    images={[{src:modePhoto ? info.src : photoReportPreview, alt:''}]}
                    zIndex={2000}
                />
                <Paper square className={classes.paper}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} style={{display:'flex', justifyContent:'center', height:50}}>
                            <Grid container justifyContent='flex-end'>
                                <Grid item xs={10}>
                                {
                                    !showElement &&
                                    <input 
                                        type="file" 
                                        onChange={handleImageChangeReport} 
                                        className={classes.inputUp}
                                        disabled={modePhoto}
                                    />
                                }
                                </Grid>
                                <Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
                                    <IconButton onClick={handleDeleteImage} size='medium'>
                                        <DeleteForeverIcon style={{color:'red'}}/>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.rootCard}>
                                <CardHeader
                                    title={<Chip color='primary' icon={isSelectElement ? <DoneIcon /> : <HelpIcon/>} label='foto_Referencia' style={{textOverflow:'ellipsis', overflow:'none', width:200}}/> }
                                />
                                <React.Fragment>
                                    {
                                        modePhoto ?
                                        <CardMedia
                                            className={classes.media}
                                            image={info.src}
                                            title='foto_Referencia'
                                            onClick={HandleShowPhotos}
                                        />:
                                        <React.Fragment>
                                            {photoReportPreview !== '' &&
                                                <CardMedia
                                                    className={classes.media}
                                                    image={photoReportPreview}
                                                    title={photoReportPreview === '' ? '' :photoReport.name}
                                                    onClick={HandleShowPhotos}
                                                />
                                            }
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                                
                            </Card>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Button variant="contained" fullWidth size="large" color="primary" startIcon={getUpImage ?<LoadingOutlinedIcon/> : <CloudUploadIcon/>} disabled={!isSelectElement} onClick={handleSubmitPhotoReport}>
                                    SUBIR
                                </Button>
                            </Grid>
                    </Grid>      
                </Paper>
            </Grid>
        </Grid>
    );
};

export default UploadElementYouNET;